import { FormlyFieldConfig, FormlyExtension } from '@ngx-formly/core';

export class PasswordToggleFormlyExtension implements FormlyExtension {
  onPopulate(field: FormlyFieldConfig) {
    if (
      !field.props ||
      (field.wrappers && field.wrappers.indexOf('password-toggle') !== -1)
    ) {
      return;
    }

    if (field.props['passwordToggle']) {
      field.wrappers = [...(field.wrappers || []), 'password-toggle'];
    }
  }
}
